"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var operators_1 = require("rxjs/operators");
var material_1 = require("@angular/material");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var drawer_configs_1 = require("./model/drawer-configs");
var drawer_events_manager_service_1 = require("./services/drawer-events-manager.service");
var drawer_constants_1 = require("./model/drawer-constants");
var EjusticeShellContainerComponent = /** @class */ (function () {
    function EjusticeShellContainerComponent(eventBase, drawerEventsManagerService) {
        this.eventBase = eventBase;
        this.drawerEventsManagerService = drawerEventsManagerService;
        this.types = drawer_configs_1.DrawerTypes;
        // Private
        this._destroy$ = new Subject_1.Subject();
    }
    EjusticeShellContainerComponent.prototype.ngOnInit = function () {
        this.handleEditorListening();
        this.subscribeOnInit();
        this.subscribeOnComplite();
    };
    EjusticeShellContainerComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    EjusticeShellContainerComponent.prototype.closeDrawer = function () {
        this.drawer.close();
        this.resetData();
    };
    EjusticeShellContainerComponent.prototype.saveChange = function () {
        this.drawerEventsManagerService.onSaveTrigger.next(true);
    };
    EjusticeShellContainerComponent.prototype.handleEditorListening = function () {
        var _this = this;
        this.eventBase.listen(drawer_constants_1.DrawerConstants.OPEN_DOCUMENT_EDITOR)
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (response) {
            if (!_this.data) {
                _this.data = response.data;
            }
            else {
                console.warn('Drawer already opened...');
            }
        });
    };
    EjusticeShellContainerComponent.prototype.subscribeOnInit = function () {
        var _this = this;
        this.drawerEventsManagerService.onInitComplete
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (result) {
            _this.drawer.open();
        });
    };
    EjusticeShellContainerComponent.prototype.subscribeOnComplite = function () {
        var _this = this;
        this.drawerEventsManagerService.onSaveComplete
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (result) {
            _this.eventBase.publish(_this.data.configs.closeEventName + "-" + _this.data.id, result);
            _this.drawer.close();
            _this.resetData();
        });
    };
    EjusticeShellContainerComponent.prototype.resetData = function () {
        this.data = null;
    };
    __decorate([
        core_1.ViewChild('drawer'),
        __metadata("design:type", material_1.MatDrawer)
    ], EjusticeShellContainerComponent.prototype, "drawer", void 0);
    EjusticeShellContainerComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-shell-container',
            styles: [require('./ejustice-shell-container.component.css')],
            template: require('./ejustice-shell-container.component.html')
        }),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.EventBase,
            drawer_events_manager_service_1.DrawerEventsManagerService])
    ], EjusticeShellContainerComponent);
    return EjusticeShellContainerComponent;
}());
exports.EjusticeShellContainerComponent = EjusticeShellContainerComponent;
//# sourceMappingURL=ejustice-shell-container.component.js.map